import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('input', this.format.bind(this))
  }

  format(e) {
    const raw = e.target.value.replace(/\D/g, '').substring(0, 8)
    const month = raw.substring(0, 2)
    const day = raw.substring(2, 4)
    const year = raw.substring(4, 8)

    if (raw.length > 4) {
      e.target.value = `${month}-${day}-${year}`
    } else if (raw.length > 2) {
      e.target.value = `${month}-${day}`
    } else {
      e.target.value = raw
    }
  }
}
